import React, { useState } from 'react'
import { Accordion, Icon, AccordionTitleProps, Image, Card, Popup } from 'semantic-ui-react'
import ModuleUtils from '../lib/ModuleUtils'

interface AccordionState {
  activeIndex: number;
}

interface ModuleAccordionProps {
  popupDisplayRef: React.RefObject<HTMLDivElement>;
}

const ModuleAccordion: React.FC<ModuleAccordionProps> = (props: ModuleAccordionProps) => {
  const Modules = ModuleUtils.getModules()
  const [accordion, setAccordion] = useState<AccordionState>({ activeIndex: Modules.length + 1 })

  const handleAccordionClick = (e: any, accordionElement: AccordionTitleProps) => {
    const { index } = accordionElement
    const newIndex: any = accordion.activeIndex === index ? -1 : index
    setAccordion({ ...accordion, activeIndex: newIndex })
  }

  const addModuleToEvent = (event: any) => {
    event.dataTransfer.setData('category', event.target.dataset.category)
    event.dataTransfer.setData('name', event.target.dataset.name)
  }

  return (
    <Accordion styled>
      {
        Modules.map((item, gIdx) => (
          <div key={item.groupName}>
            <Accordion.Title
              style={{ fontSize: '1.5rem', textAlign: 'left' }}
              active={accordion.activeIndex === gIdx}
              index={gIdx}
              onClick={handleAccordionClick}
            >
              <Icon name='dropdown' />
              {item.groupName}
            </Accordion.Title>
            <Accordion.Content active={accordion.activeIndex === gIdx}>
              <div style={{ height: '2rem' }} />
              <Card.Group style={{ maxHeight: '35vh', overflow: 'auto' }} left='left'>
                {item.modules.map(Module => (
                  <Popup
                    key={Module.Name}
                    content={Module.Description}
                    context={props.popupDisplayRef}
                    wide
                    trigger={
                      (
                        <Card key={`${item.groupName}.${Module.Name}`} style={{ width: '5rem', height: '5rem', cursor: 'move' }}>
                          <Image
                            data-name={Module.Name}
                            data-category={Module.Category}
                            onDragStart={addModuleToEvent}
                            style={{ width: '5rem', height: '5rem' }}
                            src={Module.Image}
                          />
                        </Card>
                      )
                    }
                  />
                ))}
              </Card.Group>
            </Accordion.Content>
          </div>
        ))
      }
    </Accordion>
  )
}

export default ModuleAccordion
